import React from "react";
import { useTranslation } from "react-i18next";
import TeamMemberCard from "./TeamMemberCard";

const TeamMemberGrid = ({
  members,
  searchQuery,
  onSearchChange,
  onRemove,
  onCancel,
  isLoading,
  emptyTitle,
  emptyText,
  emptyAction,
  showSearch = true,
}) => {
  const { t, i18n } = useTranslation();

  if (isLoading) {
    return (
      <div className="team-loading" dir={i18n.dir()} lang={i18n.language}>
        <div className="team-spinner" />
        <span>{t("manageTeam.current.loading", "Loading team...")}</span>
      </div>
    );
  }

  if (members.length === 0) {
    return (
      <div className="team-empty" dir={i18n.dir()} lang={i18n.language}>
        <div className="team-empty-icon">
          <svg width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
            <path d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
          </svg>
        </div>
        <h3 className="team-empty-title">{emptyTitle || t("manageTeam.current.empty", "No team members found")}</h3>
        <p className="team-empty-text">{emptyText}</p>
        {emptyAction}
      </div>
    );
  }

  return (
    <>
      {showSearch && (
        <div className="team-toolbar" dir={i18n.dir()} lang={i18n.language}>
          <div className="team-search-wrapper">
            <span className="team-search-icon">
              <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8" />
                <path d="M21 21l-4.35-4.35" />
              </svg>
            </span>
            <input
              type="text"
              className="team-search"
              placeholder={t("manageTeam.invite.searchPlaceholder", "Search by name")}
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
            />
          </div>
        </div>
      )}
      <div className="team-grid" dir={i18n.dir()} lang={i18n.language}>
        {members.map((member) => (
          <TeamMemberCard
            key={member.id}
            member={member}
            onRemove={onRemove}
            onCancel={onCancel}
          />
        ))}
      </div>
    </>
  );
};

export default TeamMemberGrid;
